function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { createBreakpointMap } from '../helpers/styled-helpers';
import HiddenInput from '../input/hidden/style';
import { StyledSwitchNo, StyledSwitchThumb, StyledSwitchTrack, StyledSwitchWrapper, StyledSwitchYes, StyledTypography } from './style';
export default class Switch extends React.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "state", void 0);

    _defineProperty(this, "sizeMap", void 0);

    _defineProperty(this, "colorMap", void 0);

    _defineProperty(this, "typographyStyle", void 0);

    _defineProperty(this, "spaceProps", void 0);

    _defineProperty(this, "handleChangeEvent", e => {
      var {
        name,
        onChange
      } = this.props;
      this.setState(state => ({
        checked: !state.checked
      }), () => {
        if (onChange) {
          onChange({
            name,
            value: this.state.checked
          });
        }
      });
      e.preventDefault();
    });

    var {
      checked,
      colorType,
      size,
      name: _name,
      onChange: _onChange,
      className
    } = props,
        spaceProps = _objectWithoutProperties(props, ["checked", "colorType", "size", "name", "onChange", "className"]);

    this.spaceProps = spaceProps;
    this.sizeMap = createBreakpointMap(size);
    this.colorMap = createBreakpointMap(colorType);
    this.state = {
      checked: checked || false
    };
    var switchSizeToTypographyStyleMap = {
      large: 'heading7',
      small: 'heading8'
    };

    if (Array.isArray(size)) {
      this.typographyStyle = size.map(val => switchSizeToTypographyStyleMap[val]);
    } else {
      this.typographyStyle = switchSizeToTypographyStyleMap[size];
    }
  }

  componentDidUpdate() {
    if (this.props.checked !== undefined && this.state.checked !== this.props.checked) {
      this.setState({
        checked: !!this.props.checked
      });
    }
  }

  render() {
    return /*#__PURE__*/React.createElement(StyledSwitchWrapper, _extends({
      onClick: this.handleChangeEvent,
      sizeMap: this.sizeMap,
      colorMap: this.colorMap,
      checked: this.state.checked,
      className: this.props.className
    }, this.spaceProps), /*#__PURE__*/React.createElement(HiddenInput, {
      checked: this.state.checked,
      onChange: this.handleChangeEvent,
      type: 'checkbox',
      name: this.props.name
    }), /*#__PURE__*/React.createElement(StyledSwitchTrack, null), /*#__PURE__*/React.createElement(StyledSwitchThumb, {
      checked: this.state.checked
    }), /*#__PURE__*/React.createElement(StyledSwitchNo, {
      checked: this.state.checked
    }, /*#__PURE__*/React.createElement(StyledTypography, {
      color: 'white',
      type: this.typographyStyle
    }, "N")), /*#__PURE__*/React.createElement(StyledSwitchYes, {
      checked: this.state.checked
    }, /*#__PURE__*/React.createElement(StyledTypography, {
      color: 'white',
      type: this.typographyStyle
    }, "Y")));
  }

}